import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';

@Component
export default class PropertyInfoDetail extends Vue {
   public title: string = 'PropertyInfoDetail';

   @Prop()
   public data: any;

   public displayData: any = {
      price: 'N/A',
      priceUnit: 'N/A',
      fullAddress: 'N/A',
      bedRooms: 'N/A',
      bedroomsPlus: 'N/A',
      washrooms: 'N/A',
      otherFee: 'N/A',
      openHouse: 'N/A',

      utilityIncludes: 'N/A',
      utilityFeatures: 'N/A',
      tax: 'N/A',
      condoFeatures: 'N/A',
      otherFeatures: 'N/A',
      poolInfo: 'N/A',
      basements: 'N/A',
      crossStreets: 'N/A',
   };

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         Object.keys(val).map((key: string) => {
            this.displayData[key] = this.dataMapper(val[key]);
         });
      }
   }

   public dataMapper(data: string) {
      if (T_T.simpleDetect(data) && data !== '-') {
         return data;
      }
      return 'N/A';
   }
}
